/*  MUI  */
import { Grid, Paper } from '@mui/material';

/*  Shared  */
import { UserApplicationActivityTable } from 'application/Shared/Components/Tables/UserApplicationActivityTable';
import { Application as ApplicationType } from 'application/Shared/types/application';
import { TenantApp } from 'application/Shared/types/tenantApp';

/* Flags */
import { INCIDENTS, hasFeature } from 'featureFlags/src';

/*  React  */
import React from 'react';

/* Internal Components */
import { AppStatusDetails } from './Pages/AppStatusDetails';
import { AppDetailsContractAlert } from './internal/AppDetailsContractAlert';
import { AppDetailsSettings } from './internal/AppDetailsSettings';
import { AppDetailsVendorIncidents } from './internal/AppDetailsVendorIncidents';

export const AppDetails = ({
    application,
    reloadApplication,
    tenantApp
}: {
    application: ApplicationType;
    reloadApplication: () => void;
    tenantApp: TenantApp;
}) => (
    <Grid container spacing={3} alignItems="stretch">
        <AppDetailsContractAlert tenantApp={tenantApp} />
        <Grid item xs={12} lg={7}>
            <Paper
                elevation={0}
                variant="outlined"
                sx={{ height: '100%', padding: '24px' }}
            >
                <AppDetailsSettings
                    application={application}
                    reloadApplication={reloadApplication}
                    tenantApp={tenantApp}
                />
            </Paper>
        </Grid>
        <Grid item xs={12} lg={5}>
            <Grid container alignItems="stretch" sx={{ height: '100%' }}>
                <Grid item xs={12}>
                    <Paper
                        elevation={0}
                        variant="outlined"
                        sx={{ height: '100%', padding: 0 }}
                    >
                        <AppDetailsVendorIncidents
                            applicationId={application.id}
                        />
                    </Paper>
                </Grid>
                {hasFeature(INCIDENTS) && (
                    <Grid item xs={12} sx={{ marginTop: '24px' }}>
                        <Paper
                            elevation={0}
                            variant="outlined"
                            style={{ height: '100%', padding: '8px' }}
                        >
                            <AppStatusDetails applicationId={application.id} />
                        </Paper>
                    </Grid>
                )}
            </Grid>
        </Grid>
        <Grid item xs={12}>
            <UserApplicationActivityTable applicationId={application.id} />
        </Grid>
    </Grid>
);
